module.exports = __webpack_public_path__ + "img/2x.d71c1c1.jpg";